module.exports = __webpack_public_path__ + "static/martha-stories-kibble-faaae5995d03b4a4be1497de5e5d89d9.mp4";